import React from 'react';
import BadgeBase from '@material-ui/core/Badge';

const Badge = ({ children, ...props }) => (
  <BadgeBase {...props}>{children}</BadgeBase>
);

export default Badge;
